import { Inject, Injectable } from '@angular/core';
import { L10n, L10nBase } from '@skylab-angular-shared/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { FormState } from '../form-state';
import { FormStateHandler } from './form-state-handler';

@Injectable({providedIn: 'root'})
export class ExternalErrorHandler extends FormStateHandler {
    public constructor(
        public readonly toastService: ToastService,
        @Inject(L10n) public readonly l10n: L10nBase
    ) {
        super();
    }

    protected get formState(): FormState {
        return FormState.ExternalError;
    }

    protected handle(): void {
        this.toastService.showAsync({
            type: 'error',
            text: this.l10n._T('scenes.shared.form.form-state-context.external-error.message'),
        });
    }
}
